var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-2 fill-height" },
    [
      _c("v-container", { staticClass: "d-flex pa-0 ma-0" }, [
        _c("div", { staticClass: "h5 font-weight-bold" }, [
          _vm._v("Esecuzione viaggio"),
        ]),
      ]),
      _c(
        "v-row",
        { staticClass: "fill-height", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            {
              staticClass: "pr-2 d-flex flex-column",
              attrs: { cols: "12", md: "6" },
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-3", attrs: { outlined: "", flat: "" } },
                [
                  _c("v-card-text", { staticClass: "d-flex flex-row pa-0" }, [
                    _c(
                      "div",
                      { staticClass: "flex-grow-1 pr-2 d-flex flex-column" },
                      [
                        _c(
                          "div",
                          { staticClass: "mb-5 d-flex align-center" },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("mdi-xml")]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.missionPlan?.trackingCode || "")
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mb-5 d-flex align-center" },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("mdi-xml")]
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.missionPlan?.code || "")),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mb-5 d-flex align-center" },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("mdi-truck")]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.tractor?.plate || "") +
                                  " " +
                                  _vm._s(_vm.tractor?.plateCountry.code || "")
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mb-5 d-flex align-center" },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("mdi-calendar-start")]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("formatDate")(_vm.startTime))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "flex-grow-1 pl-2 d-flex flex-column" },
                      [
                        _c(
                          "div",
                          { staticClass: "mb-5 d-flex align-center" },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("mdi-racing-helmet")]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.driver?.firstName || "") +
                                  " " +
                                  _vm._s(_vm.driver?.lastName || "")
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mb-5 d-flex align-center" },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("mdi-truck")]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.trailer?.plate || "") +
                                  " " +
                                  _vm._s(_vm.trailer?.plateCountry.code || "")
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mb-5 d-flex align-center" },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("mdi-calendar-end")]
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm._f("formatDate")(_vm.endTime))),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm.missionEventsBrowseResult
                ? _c(
                    "v-card",
                    {
                      staticClass: "mt-4 pa-4",
                      attrs: { outlined: "", flat: "" },
                    },
                    [
                      _c(
                        "v-timeline",
                        [
                          _c(
                            "v-timeline-item",
                            {
                              attrs: { color: "green" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "opposite",
                                    fn: function () {
                                      return [_c("strong", [_vm._v("Inizio")])]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                837843392
                              ),
                            },
                            _vm._l(
                              [_vm.missionEventsBrowseResult[0]],
                              function (event) {
                                return _c(
                                  "div",
                                  { key: event?.id || "new-event" },
                                  [
                                    !event
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "primary",
                                            attrs: {
                                              depressed: "",
                                              "x-small": "",
                                            },
                                            on: {
                                              click: _vm.startMissionExecution,
                                            },
                                          },
                                          [_vm._v(" Inizio missione ")]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "d-flex" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatDate(
                                                    event.eventTime
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mr-1",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.centerMapAndZoom(
                                                      "map",
                                                      event.latitude,
                                                      event.longitude
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" mdi-map-marker ")]
                                            ),
                                            event.user
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-column user-info",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "label" },
                                                      [_vm._v("Creato da")]
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          event.user.firstName
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            event.user.lastName
                                                          )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _vm._l(
                            _vm.missionPlan.activities,
                            function (activity, i) {
                              return _c(
                                "v-timeline-item",
                                {
                                  key: activity.id,
                                  staticClass: "mb-4",
                                  attrs: {
                                    right: "",
                                    small: "",
                                    color: _vm.getColor(activity),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "opposite",
                                        fn: function () {
                                          return [
                                            _c("strong", [
                                              _vm._v(_vm._s(activity.type)),
                                            ]),
                                            activity.address
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-1",
                                                        attrs: { small: "" },
                                                      },
                                                      [_vm._v("mdi-map-marker")]
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getAddress(
                                                            activity.address
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-1",
                                                        attrs: { small: "" },
                                                      },
                                                      [_vm._v("mdi-map-marker")]
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        "Indirizzo non disponibile"
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: { small: "" },
                                                  },
                                                  [_vm._v("mdi-calendar-start")]
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      activity.expectedBeginTime
                                                        ? _vm.formatDate(
                                                            activity.expectedBeginTime
                                                          )
                                                        : "Nessuna data prevista"
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: { small: "" },
                                                  },
                                                  [_vm._v("mdi-calendar-end")]
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      activity.expectedEndTime
                                                        ? _vm.formatDate(
                                                            activity.expectedEndTime
                                                          )
                                                        : "Nessuna data prevista"
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._l(
                                    _vm.missionEventsBrowseResult.filter(
                                      (e) => e.activityId === activity.id
                                    ),
                                    function (event) {
                                      return _c(
                                        "div",
                                        {
                                          key: event.id,
                                          staticClass:
                                            "d-flex align-center mb-2",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatDate(event.eventTime)
                                              ) +
                                              " "
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-2 mr-1",
                                              attrs: { small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.centerMapAndZoom(
                                                    "map",
                                                    event.latitude,
                                                    event.longitude
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" mdi-map-marker ")]
                                          ),
                                          event.user
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column user-info ml-2",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "label" },
                                                    [_vm._v("Creato da")]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        event.user.firstName
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          event.user.lastName
                                                        )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm.activityStartEnabled(i)
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "primary",
                                          attrs: {
                                            depressed: "",
                                            "x-small": "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.startMissionActivity(
                                                activity
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Inizio attività ")]
                                      )
                                    : _vm.activityEndEnabled(activity.id)
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "primary",
                                          attrs: {
                                            depressed: "",
                                            "x-small": "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.endMissionActivity(
                                                activity
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Fine attività ")]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              )
                            }
                          ),
                          _c(
                            "v-timeline-item",
                            {
                              staticClass: "align-center",
                              attrs: { color: "green", right: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "opposite",
                                    fn: function () {
                                      return [_c("strong", [_vm._v("Fine")])]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3920620470
                              ),
                            },
                            [
                              _vm.executionEndEnabled()
                                ? [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "primary",
                                        attrs: { depressed: "", "x-small": "" },
                                        on: { click: _vm.endMissionExecution },
                                      },
                                      [_vm._v(" Fine missione ")]
                                    ),
                                  ]
                                : _vm.missionEventsBrowseResult.length > 1 &&
                                  !_vm.missionEventsBrowseResult.at(-1)
                                    .activityId
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(
                                                _vm.missionEventsBrowseResult.at(
                                                  -1
                                                ).eventTime
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-1",
                                            on: {
                                              click: function ($event) {
                                                _vm.centerMapAndZoom(
                                                  "map",
                                                  _vm.missionEventsBrowseResult.at(
                                                    -1
                                                  ).latitude,
                                                  _vm.missionEventsBrowseResult.at(
                                                    -1
                                                  ).longitude
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" mdi-map-marker ")]
                                        ),
                                        _vm.missionEventsBrowseResult.at(-1)
                                          .user
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-flex flex-column user-info",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "label" },
                                                  [_vm._v("Creato da")]
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.missionEventsBrowseResult.at(
                                                        -1
                                                      ).user.firstName
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.missionEventsBrowseResult.at(
                                                          -1
                                                        ).user.lastName
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-2", attrs: { cols: "12", md: "6" } },
            [
              _c(
                "v-card",
                { staticClass: "pa-4 fill-height d-flex flex-column" },
                [
                  _c("MapContainerDemo", {
                    ref: "map",
                    staticStyle: { flex: "1" },
                    attrs: {
                      transportOrderNbr: this.transportOrder.transportOrderNbr,
                    },
                  }),
                  _c("v-card-text", [
                    _c("div", { staticClass: "d-flex flex-wrap mx-n2" }, [
                      _c(
                        "div",
                        { staticClass: "mx-2 d-flex flex-column" },
                        [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v("Eventi - Ultima posizione"),
                          ]),
                          _vm.latestPositions.events
                            ? _c(
                                "v-chip",
                                {
                                  attrs: {
                                    label: "",
                                    small: "",
                                    color: "primary",
                                    "text-color": "white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.centerMapAndZoom(
                                        "map",
                                        _vm.latestPositions.events.latitude,
                                        _vm.latestPositions.events.longitude
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-avatar",
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("mdi-map-marker"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.latestPositions.events.latitude
                                      ) +
                                      ", " +
                                      _vm._s(
                                        _vm.latestPositions.events.longitude
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "v-avatar",
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("mdi-clock"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatDate")(
                                          _vm.latestPositions.events
                                            .positionTime ||
                                            _vm.latestPositions.events.eventTime
                                        )
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-chip",
                                {
                                  attrs: {
                                    label: "",
                                    small: "",
                                    color: "#cecece",
                                  },
                                },
                                [_vm._v(" Nessuna posizione disponibile ")]
                              ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "mx-2 d-flex flex-column" },
                        [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v("GPS - Ultima posizione"),
                          ]),
                          _vm.latestPositions.GPS
                            ? _c(
                                "v-chip",
                                {
                                  attrs: {
                                    label: "",
                                    small: "",
                                    color: "primary",
                                    "text-color": "white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.centerMapAndZoom(
                                        "map",
                                        _vm.latestPositions.GPS.latitude,
                                        _vm.latestPositions.GPS.longitude
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-avatar",
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("mdi-map-marker"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.latestPositions.GPS.latitude) +
                                      ", " +
                                      _vm._s(
                                        _vm.latestPositions.GPS.longitude
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "v-avatar",
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("mdi-clock"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatDate")(
                                          _vm.latestPositions.GPS
                                            .positionTime ||
                                            _vm.latestPositions.GPS.eventTime
                                        )
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-chip",
                                {
                                  attrs: {
                                    label: "",
                                    small: "",
                                    color: "#cecece",
                                  },
                                },
                                [_vm._v(" Nessuna posizione disponibile ")]
                              ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }